/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import _, { filter } from 'lodash';
import { toast } from 'react-toastify';
import {
  getTeamFilter,
  getManagerFilter,
  getRepFilter,
  postFilterPRDDashboard,
} from '../../../api/dropdownOptionsApi';
import usePRDcontext from '../context/usePRDcontext';

function Filter() {
  const { auth, filterForm, setFilterForm, handleGenerateReport, handleClearReport } =
    useContext(usePRDcontext);

  const [regionalManagerOptions, setRegionalManagerOptions] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [mdOptions, setMDOptions] = useState([]);
  const [repOptions, setRepOptions] = useState([]);

  const loadPrdDashboardFilter = async () => {
    const request = {
      district_manager_id: [],
      med_rep_id: [],
      year: moment(filterForm?.year).format('YYYY'),
    };
    const reponse = await postFilterPRDDashboard(request);

    const { code, data } = reponse.data;
    // Regional
    if (code === '200' || data.regional_manager.length > 0) {
      const dropdownValue = data.regional_manager
        ?.filter((row) => row.id !== null)
        .map((row) => ({
          value: row.id,
          label: row.name,
        }));

      setRegionalManagerOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadPrdDashboardDistrictFilter = async () => {
    const request = {
      district_manager_id: [],
      med_rep_id: [],
      year: moment(filterForm?.year).format('YYYY'),
    };
    const reponse = await postFilterPRDDashboard(request);
    const { code, data } = reponse.data;
    // District
    if (code === '200' || data.district_manager.length > 0) {
      const dropdownValue = data.district_manager
        ?.filter((row) => row.id !== null)
        .map((row) => ({
          value: row.id,
          label: row.name,
        }));
      setManagerOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadPrdDashboardRepFilter = async () => {
    const request = {
      district_manager_id:
        filterForm?.manager_id[0].value !== null
          ? filterForm?.manager_id?.map((row) => row.label)
          : [],
      med_rep_id: [],
      year: moment(filterForm?.year).format('YYYY'),
    };
    const reponse = await postFilterPRDDashboard(request);
    const { code, data } = reponse.data;
    // REP
    if (code === '200' || data.med_rep.length > 0) {
      const dropdownValue = data.med_rep
        ?.filter((row) => row.id !== null)
        .map((row) => ({
          value: row.id,
          label: row.name,
        }));
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadPrdDashboardMdFilter = async () => {
    const request = {
      district_manager_id:
        filterForm?.manager_id[0].value !== null
          ? filterForm?.manager_id?.map((row) => row.label)
          : [],
      med_rep_id:
        filterForm?.rep_id[0].value !== null ? filterForm?.rep_id?.map((row) => row.label) : [],
      year: moment(filterForm?.year).format('YYYY'),
    };
    const reponse = await postFilterPRDDashboard(request);
    const { code, data } = reponse.data;

    // MD
    if (code === '200' || data.md.length > 0) {
      const dropdownValue = data.md
        ?.filter((row) => row.id !== null)
        .map((row) => ({
          value: row.id,
          label: row.name,
        }));
      setMDOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeDate = (value) => {
    setFilterForm({ ...filterForm, year: moment(value).format('YYYY') });
  };

  useEffect(() => {
    loadPrdDashboardRepFilter();
  }, [filterForm.manager_id, filterForm.year]);

  useEffect(() => {
    loadPrdDashboardMdFilter();
  }, [filterForm.rep_id, filterForm.year]);

  useEffect(() => {
    loadPrdDashboardFilter();
    loadPrdDashboardDistrictFilter();
  }, [filterForm.year]);

  return (
    <Box>
      <Grid container spacing={2}>
        {auth.level === 'Level 4' ? (
          <Grid md={2}>
            <Autocomplete
              id='regional_manager_id'
              multiple
              fullWidth
              options={regionalManagerOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm?.regional_manager_id}
              noOptionsText='No Specialty'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [regionalManagerOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [regionalManagerOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== regionalManagerOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  regional_manager_id: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='Regional Manager' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
        ) : (
          ''
        )}
        {auth.level === 'Level 3' ? (
          <Grid md={2}>
            <Autocomplete
              id='manager_id'
              multiple
              fullWidth
              options={managerOptions}
              autoComplete
              includeInputInList
              filterSelectedOptions
              getOptionLabel={(option) => (option.label ? option.label : '')}
              value={filterForm?.manager_id}
              noOptionsText='No DMPM'
              onChange={(e, newValue) => {
                let updatedNewValue = newValue;

                if (newValue.length === 0) {
                  // if remove all month option set default to all
                  updatedNewValue = [managerOptions[0]];
                } else if (newValue[newValue.length - 1].value === null) {
                  // if last selected in ALL, remove all other options and retain ALL
                  updatedNewValue = [managerOptions[0]];
                } else if (newValue.length !== 1) {
                  // if selected other months, remove ALL in selected options
                  updatedNewValue = newValue.filter(
                    (option) => option.value !== managerOptions[0].value,
                  );
                }

                setFilterForm({
                  ...filterForm,
                  manager_id: updatedNewValue,
                });
              }}
              isOptionEqualToValue={(option, selected) => option.value === selected.value}
              renderInput={(params) => <TextField {...params} label='DMPM' />}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
              size='small'
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid md={2}>
          <Autocomplete
            id='rep_id'
            multiple
            fullWidth
            options={repOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm?.rep_id}
            noOptionsText='No MPR'
            onChange={(e, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [repOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [repOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter((option) => option.value !== repOptions[0].value);
              }

              setFilterForm({
                ...filterForm,
                rep_id: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='MPR' />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>

        <Grid md={2}>
          <Autocomplete
            id='md_id'
            multiple
            fullWidth
            options={mdOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm?.md_id}
            noOptionsText='No MD'
            onChange={(e, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [mdOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [mdOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter((option) => option.value !== mdOptions[0].value);
              }

              setFilterForm({
                ...filterForm,
                md_id: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='MD' />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>

        <Grid md={1}>
          <DesktopDatePicker
            label='Year'
            views={['year']}
            value={filterForm?.year}
            fullWidth
            onChange={(e) => handleChangeDate(e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateReport}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleClearReport}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
